import React, { Component } from 'react';
import { getCurrentUser } from '../actions/userActions';
import { connect } from 'react-redux';
import { Spinner, SpinnerSize, MessageBar, MessageBarType } from '@fluentui/react';
import * as microsoftTeams from "@microsoft/teams-js";

import msalInstance from '../services/Auth'

export class AuthApp extends Component {

    state = {
        isGuestAccount: false
    }

    componentDidMount() {
        if (this.props.isMsTeamsApp) {
            this._teamsSsoLogin();
        }
        else {
            this._login();
        }
    }

    _isGuestAccount(account: AccountInfo) {
        return account.idTokenClaims.idp && 
            account.idTokenClaims.idp !== `https://sts.windows.net/${account.idTokenClaims.tid}/`;
    }

    _login() {
        // msalInstance.handleRedirectCallback((error, response) => {
        //     console.log(error);
        //     // handle redirect response or error
        // });

        //Extra callback logic, only in the actual application, not in iframes in the app
        if ((window === window.parent) && window === window.top) {
            msalInstance.handleRedirectPromise()
                .then((tokenResponse) => {
                    let account = null;
                    if (!tokenResponse) {
                        const accounts = msalInstance.getAllAccounts();
                        if (accounts.length === 0) {
                            msalInstance.loginRedirect();
                            return;
                        } else {
                            account = accounts[0];
                        }
                    } else {
                        account = tokenResponse.account;
                    }

                    console.log(account);
                            
                    msalInstance.setActiveAccount(account);

                    if (this._isGuestAccount(account)) {
                        this.setState({ isGuestAccount: true });
                    }
                    else {
                        this.props.getCurrentUser();
                    }
                })
                .catch(err => {
                    console.error(err);
                });
        }
    }

    _teamsSsoLogin() {
        microsoftTeams.initialize(() => {
            this.props.getCurrentUser();
        });
    }

    
    render() {
        return (
            this.state.isGuestAccount
            ? <div style={guestErrorStyle}><MessageBar messageBarType={MessageBarType.error}>Guests accounts are not allowed. Please log in using your ABB account.</MessageBar></div>
            : <div className="App">
                {
                    this.props.isLogged
                        ? <div>
                            <div>{this.props.children}</div>
                          </div>
                        : <Spinner style={{padding: '200px'}} size={SpinnerSize.large} />
                }
            </div>
        )
    }
}

const guestErrorStyle = {
    marginTop: '10px'
}

const mapActionsToProps = {
    getCurrentUser
}

const mapStateToProps = state => ({
    currentUser: state.user.currentUser,
    isLogged: state.user.isLogged,
    isMsTeamsApp: state.app.isMsTeamsApp
})
      
export default connect(mapStateToProps, mapActionsToProps)(AuthApp);



// WEBPACK FOOTER //
// ./src/components/AuthApp.js